import styled from 'styled-components';

export const CodeInputStyled = styled.div`
	display: none;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		display: block;
	}
`;

export const InputGroupStyled = styled.div`
	gap: 4px;
	display: flex;
`;

export const CodeInputFieldStyled = styled.input<{ hasMargin: boolean }>`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-right: ${props => (props.hasMargin ? `16px` : `0`)};
	width: 43px;
	height: 58px;
	border: 1px solid rgba(0, 0, 0, 0.15);
	border-radius: 6px;
	text-align: center;
	font-size: 38px;
`;
